import React from 'react';
import './ActualitesAme.css';

const ActualitesAme = () => {
    return (
        <div className='meree'>
        <div className='containere'>
        <div className='barres2'>
            <div className='traits1'></div>
            <div className='traits2'></div>
            </div>
            <div className='titres4'>
                <h1>VOS ACTUALITES</h1>
            </div>
            <div className='lignes6'>
            </div>
            </div>
            
    </div>
    
    );
};

export default ActualitesAme;
